import { css } from 'styled-components';

export const HeaderStyles = {
  container: css`
    background: ${({ theme }) => theme.colors.bgPrimary};
    border-bottom: 1px solid ${({ theme }) => theme.colors.borderLight};
    position: sticky;
    top: 0;
    z-index: 1000;
    box-shadow: ${({ theme }) => theme.shadows.sm};
    height: 64px;
  `,
  
  content: css`
    max-width: 1920px;
    margin: 0 auto;
    padding: 0 1.5rem;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
  `,
  
  logo: css`
    display: flex;
    align-items: center;
    gap: 1rem;
    
    h1 {
      font-size: 1.25rem;
      font-weight: 600;
      color: ${({ theme }) => theme.colors.textPrimary};
      
      @media (max-width: 768px) {
        font-size: 1rem;
      }
    }
  `,
  
  homeButton: css`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    border-radius: ${({ theme }) => theme.borderRadius.md};
    background: ${({ theme }) => theme.colors.bgSecondary};
    border: 1px solid ${({ theme }) => theme.colors.borderLight};
    color: ${({ theme }) => theme.colors.textSecondary};
    transition: ${({ theme }) => theme.transitions.default};
    
    &:hover {
      background: ${({ theme }) => theme.colors.bgTertiary};
      color: ${({ theme }) => theme.colors.textPrimary};
      border-color: ${({ theme }) => theme.colors.borderMedium};
    }
    
    &:active {
      transform: scale(0.95);
    }
  `,
  
  navRight: css`
    display: flex;
    align-items: center;
    gap: 0.75rem;
    
    @media (max-width: 768px) {
      gap: 0.5rem;
    }
  `,
  
  authButton: css`
    display: flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.5rem 1rem;
    border-radius: ${({ theme }) => theme.borderRadius.md};
    font-size: 0.875rem;
    font-weight: 500;
    transition: ${({ theme }) => theme.transitions.default};
    
    ${({ $primary, theme }) => $primary ? css`
      background: ${theme.colors.primary};
      color: white;
      border: none;
      
      &:hover {
        background: ${theme.colors.primaryDark};
      }
    ` : css`
      background: ${theme.colors.bgSecondary};
      color: ${theme.colors.textSecondary};
      border: 1px solid ${theme.colors.borderLight};
      
      &:hover {
        background: ${theme.colors.bgTertiary};
        color: ${theme.colors.textPrimary};
      }
    `}
    
    @media (max-width: 768px) {
      span {
        display: none;
      }
      padding: 0.5rem;
    }
  `,
  
  searchButton: css`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    border-radius: ${({ theme }) => theme.borderRadius.md};
    background: ${({ theme }) => theme.colors.bgSecondary};
    border: 1px solid ${({ theme }) => theme.colors.borderLight};
    color: ${({ theme }) => theme.colors.textSecondary};
    transition: ${({ theme }) => theme.transitions.default};
    
    &:hover {
      background: ${({ theme }) => theme.colors.bgTertiary};
      color: ${({ theme }) => theme.colors.textPrimary};
    }
  `,
  
  themeToggle: css`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    border-radius: ${({ theme }) => theme.borderRadius.md};
    background: ${({ theme }) => theme.colors.bgSecondary};
    border: 1px solid ${({ theme }) => theme.colors.borderLight};
    color: ${({ theme }) => theme.colors.textSecondary};
    transition: ${({ theme }) => theme.transitions.default};
    
    &:hover {
      background: ${({ theme }) => theme.colors.bgTertiary};
      color: ${({ theme }) => theme.colors.textPrimary};
    }
  `,
  
  searchContainer: css`
    display: flex;
    align-items: center;
    background: ${({ theme }) => theme.colors.bgSecondary};
    border: 1px solid ${({ theme }) => theme.colors.borderLight};
    border-radius: ${({ theme }) => theme.borderRadius.md};
    padding: 0.25rem;
    
    .search-input {
      border: none;
      background: transparent;
      padding: 0.5rem 1rem;
      font-size: 0.875rem;
      color: ${({ theme }) => theme.colors.textPrimary};
      width: 300px;
      
      &:focus {
        outline: none;
      }
      
      @media (max-width: 768px) {
        width: 200px;
      }
    }
    
    button {
      background: ${({ theme }) => theme.colors.bgTertiary};
      border: none;
      border-radius: ${({ theme }) => theme.borderRadius.sm};
      width: 32px;
      height: 32px;
      font-size: 1.25rem;
      color: ${({ theme }) => theme.colors.textSecondary};
      
      &:hover {
        color: ${({ theme }) => theme.colors.textPrimary};
      }
    }
  `
};
